// extracted by mini-css-extract-plugin
module.exports = {"slideContainerWrapper":"SliderContainer__slideContainerWrapper___1KON9","slideCurtain":"SliderContainer__slideCurtain___2n6gP","safeArea":"SliderContainer__safeArea___Oeusu"};